import React, { useState, useCallback } from 'react'
import { DATA_TABLE_OPTIONS } from 'constants'
import { GridPagination } from 'components'

/**
 * Handles all pagination and prop generation of data grid
 * @returns {[object, object]} - [dataGridProps, { page, pageSize }]
 * @description - dataGridProps - can be deestructured in mui datagrid component for common project _props for server pagination
 * { page, pageSize } - are exposed if needed for api query building
 */
export default function useDataGridDefaults() {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(
    DATA_TABLE_OPTIONS.rowPerPageDefault
  )

  const handlePageSizeChange = useCallback(
    (newPageSize) => {
      setPage(0)
      setPageSize(newPageSize)
    },
    [pageSize]
  )

  const PaginationComponent = React.useCallback(
    () => <GridPagination pageSize={pageSize} />,
    [pageSize]
  )

  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : DATA_TABLE_OPTIONS.spaceBetweenRows,
      bottom: params.isLastVisible ? 0 : DATA_TABLE_OPTIONS.spaceBetweenRows,
    }
  }, [])

  return [
    {
      pageSize: pageSize,
      page: page,
      getRowSpacing: getRowSpacing,
      onPageChange: (newPage) => setPage(newPage),
      onPageSizeChange: handlePageSizeChange,
      components: { Pagination: PaginationComponent },
      paginationMode: 'server',
      sortingMode: 'server',
    },
    { page: page, pageSize: pageSize },
  ]
}
